<template>
  <div>
    <div class="relative h-[50vh] w-screen lg:-mt-nav-lg">
      <AppImage
        :asset="data.background_image"
        class="absolute size-full object-cover"
        :class="{ 'max-lg:hidden': data.mobile_image }"
      />
      <AppImage
        v-if="data.mobile_image"
        :asset="data.mobile_image"
        sizes="xs:100vw sm:100vw md:100vw"
        class="absolute size-full object-cover lg:hidden"
      />
      <ShopCategoryBrandLogo
        :category="category"
        class="absolute left-4 max-sm:bottom-4 sm:left-20 lg:top-36"
      />
      <div class="absolute bottom-10 left-20 right-5">
        <h1 class="text-3xl font-bold text-white max-sm:hidden">
          {{ getTranslatedProperty(category, 'name') }}
        </h1>
        <div
          v-if="relatedCategories"
          class="mt-4 line-clamp-2 flex gap-2 overflow-hidden max-sm:hidden"
        >
          <NuxtLink
            v-for="tag in relatedCategories"
            :key="tag.id"
            :to="getCategoryRoute(tag)"
            class="whitespace-nowrap rounded-full bg-white px-4 py-2 text-xs font-semibold transition-colors hover:bg-black hover:text-white"
          >
            {{ getTranslatedProperty(tag, 'name') }}
          </NuxtLink>
        </div>
      </div>
    </div>
    <Container>
      <h1 class="mt-3 text-3xl font-bold text-black sm:hidden">
        {{ getTranslatedProperty(category, 'name') }}
      </h1>
    </Container>
  </div>
</template>

<script setup lang="ts">
import { getTranslatedProperty } from '@shopware/helpers'
import type { AssetFragment } from '#gql'
import type { Schemas } from '#shopware'

const props = defineProps<{
  category: Schemas['Category']
  data: {
    background_image: AssetFragment
    mobile_image?: AssetFragment
  }
}>()

const { apiClient } = useShopwareContext()
const { getCategoryRoute } = useShopRouter()

const { data: relatedCategories } = await useAsyncData(
  `${props.category.id}-tags`,
  async (): Promise<Schemas['Category'][]> => {
    const { data } = await apiClient.invoke(
      'getRelatedCategories get /teamnovu/category/{categoryId}/related',
      {
        pathParams: {
          categoryId: props.category.id,
        },
      }
    )
    return data ?? []
  }
)
</script>
